export const headerData = {
  id: 3,
  documentId: 'xghyr13hcelh9q9w28yeblbz',
  name: 'Acko homepage',
  logoUrls: true,
  darkThemeLogoUrl: 'https://acko-brand.ackoassets.com/brand/vector-svg/gradient/gradient-horizontal.svg',
  lightThemeLogoUrl: 'https://acko-brand.ackoassets.com/brand/vector-svg/gradient/gradient-horizontal.svg',
  showLoginStatus: true,
  createdAt: '2025-12-05T05:51:11.622Z',
  updatedAt: '2025-12-19T06:08:50.120Z',
  publishedAt: '2025-12-19T06:08:50.178Z',
  locale: 'en',
  leftSideCategories: [
    {
      id: 22,
      documentId: 'vo2xjqagtujxdtm4kl7ccdsa',
      name: 'Products',
      title: 'Products',
      navMode: 'navDropdown',
      dropDownType: 'fullWidth',
      priority: 2,
      createdAt: '2025-12-05T05:44:06.132Z',
      updatedAt: '2025-12-24T14:34:49.675Z',
      publishedAt: '2025-12-24T14:34:49.883Z',
      locale: 'en',
      bannerProps: {
        bannerType: 'travel-pass',
        eventProps: {},
        redirectionUrl: '/travel/domestic-pass/purchase/',
      },
      categorySections: [
        {
          id: 53,
          title: 'Car insurance',
          mobileTitle: 'Car',
          isExpandable: true,
          iconComponent: 'Car',
          sectionOptions: [
            {
              id: 609,
              title: 'Car insurance',
              desktopUrl: '/car-insurance/',
              mobileUrl: '/car-insurance/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
            {
              id: 610,
              title: 'Comprehensive car insurance',
              desktopUrl: '/car-insurance/comprehensive-car-insurance/',
              mobileUrl: '/car-insurance/comprehensive-car-insurance/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
            {
              id: 611,
              title: 'Third party car insurance',
              desktopUrl: '/third-party-car-insurance/',
              mobileUrl: '/third-party-car-insurance/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
            {
              id: 612,
              title: 'Own damage car insurance',
              desktopUrl: '/car-insurance/own-damage-insurance/',
              mobileUrl: '/car-insurance/own-damage-insurance/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
            {
              id: 613,
              title: 'Zero depreciation car insurance',
              desktopUrl: '/car-insurance/zero-depreciation/',
              mobileUrl: '/car-insurance/zero-depreciation/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
          ],
          redirectionData: null,
        },
        {
          id: 54,
          title: 'Bike insurance',
          mobileTitle: 'Bike',
          isExpandable: true,
          iconComponent: 'Bike',
          sectionOptions: [
            {
              id: 614,
              title: 'Bike insurance',
              desktopUrl: '/two-wheeler-insurance/',
              mobileUrl: '/two-wheeler-insurance/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
            {
              id: 615,
              title: 'Scooter insurance',
              desktopUrl: '/scooter-insurance/',
              mobileUrl: '/scooter-insurance/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
            {
              id: 616,
              title: 'Brand new bike insurance',
              desktopUrl: '/two-wheeler-insurance/for-new-bikes/',
              mobileUrl: '/two-wheeler-insurance/for-new-bikes/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
            {
              id: 617,
              title: 'Comprehensive bike insurance',
              desktopUrl: '/two-wheeler-insurance/comprehensive-bike-insurance/',
              mobileUrl: '/two-wheeler-insurance/comprehensive-bike-insurance/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
            {
              id: 618,
              title: 'Third party bike insurance',
              desktopUrl: '/third-party-bike-insurance/',
              mobileUrl: '/third-party-bike-insurance/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
          ],
          redirectionData: null,
        },
        {
          id: 55,
          title: 'Health insurance',
          mobileTitle: 'Health',
          isExpandable: true,
          iconComponent: 'HealthCheckup',
          sectionOptions: [
            {
              id: 619,
              title: 'Health insurance',
              desktopUrl: '/health-insurance/',
              mobileUrl: '/health-insurance/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
            {
              id: 620,
              title: 'Health insurance Plans for Family',
              desktopUrl: '/health-insurance/health-insurance-plans-for-family/',
              mobileUrl: '/health-insurance/health-insurance-plans-for-family/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
            {
              id: 621,
              title: 'Health Insurance Premium Calculator',
              desktopUrl: '/health-insurance/premium-calculator/',
              mobileUrl: '/health-insurance/premium-calculator/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
            {
              id: 622,
              title: 'Health Insurance for Parents',
              desktopUrl: '/health-insurance/for-parents/',
              mobileUrl: '/health-insurance/for-parents/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
            {
              id: 623,
              title: 'Best Health Insurance in India',
              desktopUrl: '/health-insurance/best-health-insurance-plans-in-india/',
              mobileUrl: '/health-insurance/best-health-insurance-plans-in-india/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
            {
              id: 624,
              title: 'Senior Citizen Health Insurance',
              desktopUrl: '/health-insurance/senior-citizens/',
              mobileUrl: '/health-insurance/senior-citizens/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
            {
              id: 625,
              title: 'Section 80D',
              desktopUrl: '/health-insurance/section80d-deductions/',
              mobileUrl: '/health-insurance/section80d-deductions/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
          ],
          redirectionData: null,
        },
        {
          id: 56,
          title: 'Life insurance',
          mobileTitle: 'Life',
          isExpandable: true,
          iconComponent: 'Life',
          sectionOptions: [
            {
              id: 626,
              title: 'Life insurance',
              desktopUrl: '/life-insurance/',
              mobileUrl: '/life-insurance/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
            {
              id: 627,
              title: 'Term insurance',
              desktopUrl: '/life-insurance/term-insurance/',
              mobileUrl: '/life-insurance/term-insurance/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
            {
              id: 628,
              title: 'Term Insurance Calculator',
              desktopUrl: '/calculators/term-insurance-calculator/',
              mobileUrl: '/calculators/term-insurance-calculator/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
            {
              id: 629,
              title: '1 Crore Term Insurance',
              desktopUrl: '/life-insurance/1-crore-term-insurance/',
              mobileUrl: '/life-insurance/1-crore-term-insurance/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
          ],
          redirectionData: null,
        },
        {
          id: 57,
          title: 'Travel insurance',
          mobileTitle: 'Travel',
          isExpandable: true,
          iconComponent: 'Luggage',
          sectionOptions: [
            {
              id: 630,
              title: 'Travel insurance',
              desktopUrl: '/travel-insurance/',
              mobileUrl: '/travel-insurance/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
            {
              id: 631,
              title: 'International travel insurance',
              desktopUrl: '/international-travel-insurance/',
              mobileUrl: '/international-travel-insurance/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
            {
              id: 632,
              title: 'Travel insurance for Schengen visa',
              desktopUrl: '/visa/schengen-visa/',
              mobileUrl: '/visa/schengen-visa/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
            {
              id: 633,
              title: 'ACKO Airpass',
              desktopUrl: '/travel-insurance/domestic-airpass/',
              mobileUrl: '/travel-insurance/domestic-airpass/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
          ],
          redirectionData: null,
        },
      ],
      redirectionData: null,
      localizations: [],
    },
    {
      id: 4,
      documentId: 'ygjx8q70kslpe7c1s8y545uf',
      name: 'Enterprise',
      title: 'Enterprise',
      navMode: 'redirect',
      dropDownType: 'fullWidth',
      priority: 3,
      createdAt: '2025-12-05T04:05:37.273Z',
      updatedAt: '2025-12-05T04:05:37.273Z',
      publishedAt: '2025-12-05T04:05:37.311Z',
      locale: 'en',
      bannerProps: null,
      categorySections: [],
      redirectionData: {
        id: 4,
        title: 'Enterprise',
        desktopUrl: '/enterprise/?utm_source=direct&utm_medium=homepage',
        mobileUrl: '/enterprise/?utm_source=direct&utm_medium=homepage',
        openNewTab: true,
        forLoggedIn: true,
        forLoggedOut: true,
        lightBgImageUrl: null,
        darkBgImageUrl: null,
        iconComponent: null,
      },
      localizations: [],
    },
    {
      id: 17,
      documentId: 'd8jd7tduf7jo67tld6luofvq',
      name: 'Why ACKO?',
      title: 'Why ACKO?',
      navMode: 'navDropdown',
      dropDownType: 'fullWidth',
      priority: 4,
      createdAt: '2025-12-05T05:44:07.987Z',
      updatedAt: '2025-12-23T07:29:51.877Z',
      publishedAt: '2025-12-23T07:29:52.100Z',
      locale: 'en',
      bannerProps: {
        bannerType: 'customer-stories',
        eventProps: {},
        redirectionUrl: '/reviews-testimonials/',
      },
      categorySections: [
        {
          id: 30,
          title: 'About Us',
          mobileTitle: 'About Us',
          isExpandable: false,
          iconComponent: null,
          sectionOptions: [],
          redirectionData: {
            id: 446,
            title: 'About Us',
            desktopUrl: '/about-us/',
            mobileUrl: '/about-us/',
            openNewTab: true,
            forLoggedIn: true,
            forLoggedOut: true,
            lightBgImageUrl: 'https://acko-cms.ackoassets.com/about_us_dark_dccd6630dc.webp',
            darkBgImageUrl: 'https://acko-cms.ackoassets.com/about_us_dark_dccd6630dc.webp',
            iconComponent: 'Details',
          },
        },
        {
          id: 31,
          title: 'Careers',
          mobileTitle: 'Careers',
          isExpandable: false,
          iconComponent: 'App',
          sectionOptions: [],
          redirectionData: {
            id: 447,
            title: 'Careers',
            desktopUrl: '/careers/',
            mobileUrl: '/careers/',
            openNewTab: true,
            forLoggedIn: true,
            forLoggedOut: true,
            lightBgImageUrl: 'https://acko-cms.ackoassets.com/how_acko_works_dark_aa694cfcb9.webp',
            darkBgImageUrl: 'https://acko-cms.ackoassets.com/how_acko_works_dark_aa694cfcb9.webp',
            iconComponent: 'App',
          },
        },
        {
          id: 32,
          title: 'Customer stories',
          mobileTitle: 'Customer stories',
          isExpandable: false,
          iconComponent: 'Message',
          sectionOptions: [],
          redirectionData: {
            id: 448,
            title: 'Blog',
            desktopUrl: '/reviews-testimonials/',
            mobileUrl: '/reviews-testimonials/',
            openNewTab: true,
            forLoggedIn: true,
            forLoggedOut: true,
            lightBgImageUrl: 'https://acko-cms.ackoassets.com/customer_stories_dark_1b7f7b7755.webp',
            darkBgImageUrl: 'https://acko-cms.ackoassets.com/customer_stories_dark_1b7f7b7755.webp',
            iconComponent: 'Message',
          },
        },
      ],
      redirectionData: null,
      localizations: [],
    },
    {
      id: 11,
      documentId: 'qvao1jo5xv7eufxqucczv5gb',
      name: 'Support',
      title: 'Support',
      navMode: 'redirect',
      dropDownType: 'fullWidth',
      priority: 8,
      createdAt: '2025-12-05T05:44:07.038Z',
      updatedAt: '2025-12-05T05:44:07.038Z',
      publishedAt: '2025-12-05T05:44:07.057Z',
      locale: 'en',
      bannerProps: null,
      categorySections: [],
      redirectionData: {
        id: 77,
        title: 'Support',
        desktopUrl: '/contact-us/',
        mobileUrl: '/contact-us/',
        openNewTab: true,
        forLoggedIn: true,
        forLoggedOut: true,
        lightBgImageUrl: null,
        darkBgImageUrl: null,
        iconComponent: null,
      },
      localizations: [],
    },
  ],
  rightSideCategories: [
    {
      id: 23,
      documentId: 'tii13edenkhewn9xnz83c1ky',
      name: 'Renewals',
      title: 'Renewals',
      navMode: 'navDropdown',
      dropDownType: 'contentWidth',
      priority: 5,
      createdAt: '2025-12-05T05:44:07.136Z',
      updatedAt: '2026-01-07T12:09:58.066Z',
      publishedAt: '2026-01-07T12:09:58.135Z',
      locale: 'en',
      bannerProps: null,
      categorySections: [
        {
          id: 58,
          title: 'New to ACKO?',
          mobileTitle: null,
          isExpandable: true,
          iconComponent: null,
          sectionOptions: [
            {
              id: 634,
              title: 'Renew health insurance',
              desktopUrl: '/myaccount',
              mobileUrl: '/myaccount',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: 'https://acko-cms.ackoassets.com/health_insurance_dark_07867bf6b3.webp',
              darkBgImageUrl: 'https://acko-cms.ackoassets.com/health_insurance_dark_07867bf6b3.webp',
              iconComponent: 'HealthCheckup',
            },
            {
              id: 635,
              title: 'Renew car insurance',
              desktopUrl: '/myaccount',
              mobileUrl: '/myaccount',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: 'https://acko-cms.ackoassets.com/car_insurance_dark_e4818cf77a.webp',
              darkBgImageUrl: 'https://acko-cms.ackoassets.com/car_insurance_dark_e4818cf77a.webp',
              iconComponent: 'Car',
            },
            {
              id: 636,
              title: 'Renew bike insurance',
              desktopUrl: '/myaccount',
              mobileUrl: '/myaccount',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: 'https://acko-cms.ackoassets.com/bike_insurance_dark_14892f8fc3.webp',
              darkBgImageUrl: 'https://acko-cms.ackoassets.com/bike_insurance_dark_14892f8fc3.webp',
              iconComponent: 'Bike',
            },
            {
              id: 637,
              title: 'Renew life insurance',
              desktopUrl: '/myaccount',
              mobileUrl: '/myaccount',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: 'https://acko-cms.ackoassets.com/life_insurance_dark_1cc490ac3e.webp',
              darkBgImageUrl: 'https://acko-cms.ackoassets.com/life_insurance_dark_1cc490ac3e.webp',
              iconComponent: 'Life',
            },
          ],
          redirectionData: null,
        },
        {
          id: 59,
          title: 'Existing ACKO Customer',
          mobileTitle: null,
          isExpandable: true,
          iconComponent: null,
          sectionOptions: [
            {
              id: 638,
              title: 'Login and renew policy',
              desktopUrl:
                '/authn/v1/signin?client_id=acko_webapp&redirect_uri=https%3A%2F%2Fwww.acko.com%2Fplatform%2Fauth%2Ftoken%2Facko_webapp&response_type=code&identity_type=d2c&scope=offline_access&realm=acko',
              mobileUrl:
                '/authn/v1/signin?client_id=acko_webapp&redirect_uri=https%3A%2F%2Fwww.acko.com%2Fplatform%2Fauth%2Ftoken%2Facko_webapp&response_type=code&identity_type=d2c&scope=offline_access&realm=acko',
              openNewTab: true,
              forLoggedIn: false,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: 'Login',
            },
          ],
          redirectionData: null,
        },
      ],
      redirectionData: null,
      localizations: [],
    },
    {
      id: 7,
      documentId: 'l4n7qtthd16lahbg5fd6x2hc',
      name: 'Claims',
      title: 'Claims',
      navMode: 'outlined-button',
      dropDownType: 'contentWidth',
      priority: 6,
      createdAt: '2025-12-05T05:44:05.657Z',
      updatedAt: '2025-12-05T05:44:05.657Z',
      publishedAt: '2025-12-05T05:44:05.719Z',
      locale: 'en',
      bannerProps: null,
      categorySections: [
        {
          id: 3,
          title: 'File a claim',
          mobileTitle: 'File a new claim',
          isExpandable: false,
          iconComponent: null,
          sectionOptions: [],
          redirectionData: {
            id: 29,
            title: 'File a claim',
            desktopUrl: '/myaccount',
            mobileUrl: '/myaccount',
            openNewTab: true,
            forLoggedIn: true,
            forLoggedOut: true,
            lightBgImageUrl: 'https://acko-cms.ackoassets.com/File_new_claim_new_dark_4a09d138d1.webp',
            darkBgImageUrl: 'https://acko-cms.ackoassets.com/File_new_claim_new_dark_4a09d138d1.webp',
            iconComponent: 'Claim',
          },
        },
        {
          id: 4,
          title: 'Track a claim',
          mobileTitle: 'Track existing claim',
          isExpandable: false,
          iconComponent: null,
          sectionOptions: [],
          redirectionData: {
            id: 30,
            title: 'Track a claim',
            desktopUrl: '/myaccount',
            mobileUrl: '/myaccount',
            openNewTab: true,
            forLoggedIn: true,
            forLoggedOut: true,
            lightBgImageUrl: 'https://acko-cms.ackoassets.com/Track_claim_new_dark_6fd86ac08a.webp',
            darkBgImageUrl: 'https://acko-cms.ackoassets.com/Track_claim_new_dark_6fd86ac08a.webp',
            iconComponent: 'Tracking',
          },
        },
      ],
      redirectionData: null,
      localizations: [],
    },
    {
      id: 2,
      documentId: 'k8nk7mx0tp09xagglnh67f0i',
      name: 'My policies',
      title: 'My policies',
      navMode: 'redirect',
      dropDownType: 'fullWidth',
      priority: 1,
      createdAt: '2025-12-05T04:01:28.445Z',
      updatedAt: '2025-12-05T04:01:28.445Z',
      publishedAt: '2025-12-05T04:01:28.482Z',
      locale: 'en',
      bannerProps: null,
      categorySections: [],
      redirectionData: {
        id: 2,
        title: 'My policies',
        desktopUrl: null,
        mobileUrl: '/myaccount',
        openNewTab: true,
        forLoggedIn: true,
        forLoggedOut: false,
        lightBgImageUrl: null,
        darkBgImageUrl: null,
        iconComponent: null,
      },
      localizations: [],
    },
  ],
  localizations: [],
}
